import React, { useEffect, useState } from 'react';

export const DEFAULT_INIT_OPTIONS = {
  flow: 'standard',
  pkceMethod: 'S256'
};

function KeycloakProvider({
  keycloakConfig,
  children,
  initOptions = DEFAULT_INIT_OPTIONS,
  LoadingComponent
}) {
  if (keycloakConfig?.keycloak) {
    return (
      <KeycloakComponent
        initOptions={initOptions}
        keycloakConfig={keycloakConfig}
        LoadingComponent={LoadingComponent}
      >
        {children}
      </KeycloakComponent>
    );
  }
  return children;
}

function KeycloakComponent({
  keycloakConfig,
  initOptions,
  LoadingComponent,
  children
}) {
  const [isLoading, setIsLoading] = useState(true);

  const { keycloak, loginOptions } = keycloakConfig;

  function onReady() {
    const loading = !keycloak.authenticated;
    setIsLoading(loading);
  }

  function onTokenExpired() {
    keycloak.updateToken(5)
  }

  useEffect(() => {
    keycloak.onReady = onReady;
    keycloak.onTokenExpired = onTokenExpired;
    keycloak.init(initOptions).then(auth => {
      if (!auth) {
        keycloak.login(loginOptions);
      }
    });
  }, []);

  if (isLoading) {
    return <LoadingComponent />;
  }

  return children;
}

export default KeycloakProvider;
